import React from 'react';
import './index.css';
import ToolSpan from './ToolSpan'

function ToolsDisplay(props) {
  return (
    <div className="row">
      <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 d-flex flex-wrap justify-content-center">
        <hr className="divider" />
        <ToolSpan>Python</ToolSpan>
        <ToolSpan>JavaScript</ToolSpan>
        <ToolSpan>Ruby</ToolSpan>
        <ToolSpan>C</ToolSpan>
        <ToolSpan>C++</ToolSpan>
        <ToolSpan>Java</ToolSpan>
        <ToolSpan>GraphQL</ToolSpan>
        <ToolSpan>SQL</ToolSpan>
        <ToolSpan>SOQL</ToolSpan>
        <ToolSpan>HTML</ToolSpan>
        <ToolSpan>CSS</ToolSpan>

        <ToolSpan>React</ToolSpan>
        <ToolSpan>Gatsby</ToolSpan>
        <ToolSpan>Redux</ToolSpan>
        <ToolSpan>React Native</ToolSpan>
        <ToolSpan>Android NDK</ToolSpan>
        <ToolSpan>Storybook</ToolSpan>
        <ToolSpan>Django</ToolSpan>
        <ToolSpan>Bootstrap</ToolSpan>
        <ToolSpan>Ruby on Rails</ToolSpan>
        <ToolSpan>JQuery</ToolSpan>
        <ToolSpan>Flask</ToolSpan>

        <ToolSpan>RSpec</ToolSpan>
        <ToolSpan>Jest</ToolSpan>
        <ToolSpan>unittest</ToolSpan>

        <ToolSpan>Anime.js</ToolSpan>
        <ToolSpan>ScrollMagic</ToolSpan>
        <ToolSpan>Chart.js</ToolSpan>
        <ToolSpan>NumPy</ToolSpan>
        <ToolSpan>TensorFlow</ToolSpan>
        <ToolSpan>Keras</ToolSpan>

        <ToolSpan>Places API</ToolSpan>
        <ToolSpan>Spotify API</ToolSpan>
        <ToolSpan>Gmail API</ToolSpan>

        <ToolSpan>Docker</ToolSpan>
        <ToolSpan>Vagrant</ToolSpan>

        <ToolSpan>PostgreSQL</ToolSpan>
        <ToolSpan>MySQL</ToolSpan>
        <ToolSpan>Graphene</ToolSpan>
        <ToolSpan>Apollo</ToolSpan>
        <ToolSpan>Axios</ToolSpan>
        <ToolSpan>Redis</ToolSpan>

        <ToolSpan>Linux</ToolSpan>
        <ToolSpan>Bash</ToolSpan>
        <ToolSpan>Git</ToolSpan>
        <ToolSpan>SVN</ToolSpan>
        <ToolSpan>CircleCI</ToolSpan>
        <ToolSpan>Postman</ToolSpan>
        <ToolSpan>cURL</ToolSpan>

        <ToolSpan>Salesforce</ToolSpan>
        <ToolSpan>Heroku</ToolSpan>
        <ToolSpan>Netlify</ToolSpan>
        <ToolSpan>Algolia</ToolSpan>
      </div>
    </div>
  )
}

export default ToolsDisplay;
